export const recipeInfo = {
  supportLangList: [],
  lang: null,
  recipeLang: {},
  photo: null,
  portionSizeList: [],
  cookingStepList: [],
  accessoryList: [],
  prepareHours: null,
  prepareMinutes: null,
  makeHours: null,
  makeMinutes: null,
  restHours: null,
  restMinutes: null,
  nutritionList: [],
  recipeCategoryCode: null,
  difficultyLevel: null,
  tags: [],
  products: [],
  confirmLangList: [],
  compatibleVersion: null,
  autoCreateStepDesc: "0",
  type: "",
};
